import {IAttributes, IAugmentedJQuery, IDirective, INgModelController, IQService, IScope} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {Throttle} from "../tjenester/Throttle";
import {BrukerRessurs} from "../tjenester/ressurser/BrukerRessurs";
import _ from "lodash";

export function validerBrukernavnForInjisering() {
    return [regNavn.ng.$q, Throttle.regNavn, BrukerRessurs.regNavn, validerBrukernavn];
}

/**
 * Validerer brukernavn vhja brukerRes.validerBrukernavn(..).
 *
 * Eksponerer feilkoden 'brukernavn' under NgModelController.$error
 */
export function validerBrukernavn($q: IQService, throttle: Throttle, brukerRes: BrukerRessurs): IDirective {

    return {
        restrict: "A",
        require: 'ngModel',
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes, $ctrl: INgModelController) {

            var throttledValider = throttle.throttle(
                (brukernavn, $scope, $ctrl: INgModelController) => {
                    brukerRes.validerBrukernavn(brukernavn).$promise
                        .then(resultat => $ctrl.$setValidity("brukernavn", resultat.gyldig));
                },
                1000);

            // bruker ikke $ctrl.$asyncValidators da vi ønsker å throttle serversidevalideringskallet og det
            // spiller ikke bra med semantikken til $ctrl.$asyncValidators
            // $viewChangeListeners vil ikke bli kalt før øvrige registrerte validatorer er OK
            // dog ser $viewChangeListeners ut til å bli ifbm første kjøring av øvrige validatorer
            $ctrl.$viewChangeListeners.push(() => {
                var brukernavn = $ctrl.$viewValue;
                if (_.size(brukernavn) < 3) return; //forhindrer kjøring ved førstegangs evaluering av validatorer
                throttledValider(brukernavn, $scope, $ctrl);
            });
        }
    };
}
